import { BaseType } from '../base/base-type';
import { MemberRetirementTypeIdEnum } from '../enum/shared/member-retirement-type-id';

export class RetirementType extends BaseType {
  public declare id: MemberRetirementTypeIdEnum;

  public isBoardDirected(): boolean {
    return this.id === MemberRetirementTypeIdEnum.BoardDirected;
  }

  public isPhased(): boolean {
    return this.id === MemberRetirementTypeIdEnum.Phased;
  }
}
